const REPORT_COLUMNS = [
  ["Request reference", (item) => item.id],
  ["Employee name", (item) => item.employeeName],
  ["Employee email", (item) => item.employeeEmail],
  ["Company", (item) => item.companyName || "No company"],
  ["Request type", (item) => item.requestType === "PhotoRemoval" ? "Photo removal" : "Photo update"],
  ["Current status", (item) => item.status],
  ["Submitted date", (item) => item.submittedDate],
  ["Completed date", (item) => item.completedDate || ""],
  ["HC decision", (item) => item.hcDecision || ""],
  ["CCD decision", (item) => item.ccdDecision || ""],
  ["Retry count", (item) => item.retryCount ?? 0],
];

function normalized(value) {
  return String(value ?? "").trim().toLowerCase();
}

function safeSpreadsheetText(value) {
  const text = String(value ?? "");
  // Prevent spreadsheet formula execution when the CSV is opened in Excel.
  return /^[=+\-@]/.test(text) ? `'${text}` : text;
}

function csvCell(value) {
  return `"${safeSpreadsheetText(value).replace(/"/g, '""')}"`;
}

export function filterReviewerRequests(items, { search = "", status = "all", type = "all", company = "all", dateFrom = "", dateTo = "" } = {}) {
  const q = normalized(search);
  // Calendar days in Saudi Arabia, inclusive at both ends (not the browser timezone).
  const start = dateFrom ? Date.parse(`${dateFrom}T00:00:00+03:00`) : -Infinity;
  const end = dateTo ? Date.parse(`${dateTo}T00:00:00+03:00`) + 86400000 : Infinity;
  if (Number.isNaN(start) || Number.isNaN(end) || start >= end) return [];
  return (Array.isArray(items) ? items : []).filter((item) => {
    const textMatch = !q || [item.employeeName, item.employeeEmail, item.companyName, item.id]
      .some((value) => normalized(value).includes(q));
    const statusMatch = status === "all" || item.status === status;
    const typeMatch = type === "all" || (type === "removal" ? item.requestType === "PhotoRemoval" : item.requestType !== "PhotoRemoval");
    const companyMatch = company === "all" || item.companyName === company;
    const submitted = Date.parse(item.submittedDate);
    const dateMatch = (!dateFrom && !dateTo) || (Number.isFinite(submitted) && submitted >= start && submitted < end);
    return textMatch && statusMatch && typeMatch && companyMatch && dateMatch;
  });
}

export function reviewerReportCsv(items) {
  const rows = [
    REPORT_COLUMNS.map(([heading]) => heading),
    ...(Array.isArray(items) ? items : []).map((item) => REPORT_COLUMNS.map(([, read]) => read(item))),
  ];
  // BOM keeps UTF-8 names readable when the report is opened in Microsoft Excel.
  return `\uFEFF${rows.map((row) => row.map(csvCell).join(",")).join("\r\n")}\r\n`;
}

export function reviewerReportFilename(now = new Date()) {
  const stamp = Number.isNaN(now.getTime()) ? "report" : now.toISOString().slice(0, 10);
  return `profile-studio-reviewer-filtered-${stamp}.csv`;
}
